<template>
  <div class="data-sub">
    <span class="title">数据报送</span>
    <div class="data-sub-body">
      <el-date-picker
        size="small"
        class="date-select"
        v-model="searchParams.date"
        align="right"
        type="month"
        placeholder="选择日期"
        :editable="false"
        value-format="yyyy-MM"
        :clearable="false"
        :picker-options="pickerOptions"
        @change="getList()"
      >
      </el-date-picker>
      <el-button
        size="small"
        style="margin-left: 16px"
        icon="el-icon-download"
        @click="downloadTable()"
        >下载</el-button
      >
      <el-table
        size="mini"
        height="calc(100% - 120px)"
        :header-cell-style="{
          background: '#f5f5f5',
        }"
        :data="dataSource"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
      >
        <el-table-column align="center" width="80" label="序号">
          <template scope="scope">
            <span>{{
              (pagination.current - 1) * pagination.pageSize + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="generateDate" label="日期">
          <template slot-scope="{ row }">
            {{ $dayjs(row.generateDate).format("YYYY-MM") }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="dangerWaster.dangerWasterList.name"
          label="危废名称"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dangerWaster.dangerWasterList.type"
          label="危险废物类别"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dangerWaster.dangerWasterList.code"
          label="危险废物代码"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dangerWaster.handleCompany.name"
          label="处置单位"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dangerWaster.isTransProvince"
          label="转移类型"
        >
          <template slot-scope="{ row }">
            {{ row.dangerWaster.isTransProvince ? "跨省转移" : "省内转移" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="lastSurplus"
          label="累计剩余量（吨）"
        >
        </el-table-column>
        <el-table-column
          width="120"
          align="center"
          prop="monthOutPut"
          :label="searchParams.date + '产生量（吨）'"
        >
          <template slot-scope="{ row }">
            <span v-if="!row.isEdit">{{ row.monthOutPut }}</span>
            <el-input
              v-else
              pattern="[0-9]*(\.[0-9]+)?"
              oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\..*)\./g,'$1')"
              v-model="row.monthOutPut"
              @focus="handleFocus"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="120"
          prop="monthDisPos"
          :label="searchParams.date + '处置量（吨）'"
        >
          <template slot-scope="{ row }">
            <el-input
              v-if="row.isEdit && row.realMonthDisPos == 0"
              pattern="[0-9]*(\.[0-9]+)?"
              oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\..*)\./g,'$1')"
              v-model="row.monthDisPos"
              @focus="handleFocus"
            ></el-input>

            <span v-else>{{ row.monthDisPos }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="surplus"
          label="截止本月剩余贮存量（吨）"
        >
        </el-table-column>

        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              v-if="!row.isEdit"
              type="primary"
              icon="el-icon-edit-outline"
              @click="changeIsEdit(row)"
              >编辑</el-button
            >
            <div v-else>
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-close"
                circle
                @click="cancleEdit(row)"
              >
              </el-button>

              <el-button
                size="mini"
                type="success"
                icon="el-icon-check"
                circle
                @click="modifyRow(row)"
              ></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="paaination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
      <!-- <a-table bordered :resizeable="true" :rowKey="(record) => record.id" :pagination="pagination" :columns="columns"
        :picker-options="pickerOptions" :data-source="dataSource" @showSizeChange="onPage" @change="({ current, pageSize }) => {
          onPage(current, pageSize);
        }
          " size="small" :scroll="tableHeight">
        <div slot="actions" slot-scope="text, record">
          <el-button type="text" style="color: #f56c6c" size="mini">删除</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button type="text" size="mini">修改</el-button>
        </div>
      </a-table> -->
    </div>
  </div>
</template>

<script>
import { paginations } from "@/../utils/public";

import { DownloadBlob } from "@/http/downloadService";
export default {
  components: {},
  data() {
    return {
      dataSource: [],
      searchParams: {
        date: this.$dayjs().format("YYYY-MM"),
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      tableHeight: { x: "100%", y: 500 },
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
        showTotal: (total) => `一共${total}条记录 `,
      },

      editData: {},
    };
  },
  computed: {},
  methods: {
    downloadTable() {
      let url = this.$api.dangerWasterDatas.downloadDangerWasterDatas;

      const data = { date: this.searchParams.date };
      DownloadBlob({
        url: url,

        data: data,
        method: "get",
      });
    },
    changeIsEdit(row) {
      if (!row.isEdit) {
        this.$set(row, "isEdit", true);
        let newRow = { ...row };
        this.editData[row.id] = newRow;
      } else row.isEdit = false;
    },
    handleFocus(event) {
      event.target.select();
    },
    getList() {
      const parames = {
        date: this.searchParams.date,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      let url = this.$api.dangerWasterDatas.getDangerWasterDatas;
      this.$axios.get(url, parames, false).then((res) => {
        if (res.data.code == 0) {
          let { data, total } = res.data.data;

          this.pagination.total = total;
          this.dataSource = data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    cancleEdit(row) {
      const { monthDisPos, monthOutPut } = this.editData[row.id];
      row.isEdit = false;
      row.monthDisPos = monthDisPos;
      row.monthOutPut = monthOutPut;
    },
    modifyRow(row) {
      if (!row.monthDisPos && row.monthDisPos !== 0) {
        this.$message({
          message: "本月处置量不能为空",
          type: "error",
        });
      }
      if (!row.monthOutPut && row.monthOutPut !== 0) {
        this.$message({
          message: "本月产生量不能为空",
          type: "error",
        });
      }

      const url = this.$api.dangerWasterDatas.modifyRow;
      const postData = { ...row };
      this.$axios
        .post(url, postData, false)
        .then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data.row;
            row.lastSurplus = data.lastSurplus;
            row.surplus = data.surplus;

            row.isEdit = false;

            this.$message({
              message: res.data.msg,
              type: "success",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.data-sub {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .data-sub-body {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .paaination {
      float: right;
    }
  }
}
</style> 